import { Navigate, useLocation } from "react-router-dom";

/**
 * Legacy `/register` links. Invitation links carry a `?code=` and go to the
 * activation form (query string preserved so `?email=` and `?code=` survive);
 * anything else is a would-be new customer and goes to self-serve sign-up.
 *
 * The redirect uses `replace` so the Back button does not bounce between pages.
 */
export function RegisterPage() {
  const location = useLocation();
  const isInvitation = new URLSearchParams(location.search).has("code");
  return (
    <Navigate to={isInvitation ? `/activate${location.search}` : "/signup"} replace />
  );
}
